{
  "title": "Put CARii on your home screen.",
  "description": "No app store, no download. It installs straight from the browser and works even when the signal in the car park doesn't.",
  "installLabel": "Install CARii",
  "installedLabel": "Installed"
}
